import StartRecordVideo from "./StartRecordVideo.svg";
import StopRecordVideo from "./StopRecordVideo.svg";

interface VideoActionProps extends React.ComponentPropsWithoutRef<"button"> {
	state: "start" | "stop";
}

const VideoAction: React.FC<VideoActionProps> = ({ state, ...props }) => {
	return (
		<button type="button" title={state} {...props}>
			<img
				src={state === "start" ? StartRecordVideo : StopRecordVideo}
				alt="Video action"
				className="w-[60px] h-[60px]"
			/>
		</button>
	);
};

export default VideoAction;
